export default __webpack_public_path__ + "static/media/10.d8fadc5b.jpg";